import { omit, cloneDeep } from 'lodash-es';
import { AgGridVue } from 'ag-grid-vue';
import tableResize from './tableResize';
import { ConfigConsumerProps } from '../config-provider/configConsumerProps';
import Vue from 'vue';

export default {
  name: 'FcTable',
  props: {
    // 按钮配置
    buttons: {
      type: Object,
      default: () => {
        return {};
      },
    },
    // 查询条件
    filters: {
      type: Object,
      default: () => {
        return {};
      },
    },
    // 分页信息
    pagination: {
      type: Object,
      default: () => {
        return {};
      },
    },
    // 表格配置
    gridOptions: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  inject: {
    configProvider: { default: () => ConfigConsumerProps }, // 注入依赖，包含组件基本class名方法
  },
  data() {
    return {
      isAdvance: false,
      rules: {
        requiredMultipleSelect: [
          // 高级搜索，数值类型的条件”介于“需要输入两个值时，输入一个值时的检索方式。
          { required: true, message: '请选择一个选项', trigger: 'change' },
        ],
      },
      current: 1,
      pageSize: 10,
      rowData: [],

      columnDefs: [],
      isSelectedAll: false,
      removeSelected: [],
      isRetract: false,
      retract: false,
      tableChecked: 0, //选中的数据
      form: this.$form.createForm(this, { name: 'horizontal_login' }),
      filtersCurrent: {},

      gridOptionsDeal: {}, //最终值为{ ...this.defaultOptions, ...this.gridOptions }
    };
  },
  computed: {
    filtersCurrentShowLength: {
      get() {
        let length = 0;
        if (this.filtersCurrent.mode === undefined || this.filtersCurrent.mode === 'normal') {
          length = (this.filtersCurrent.options && this.filtersCurrent.options.length) || 0;
        } else if (this.filtersCurrent.mode === 'auto') {
          length =
            ((!this.$slots.forms &&
              this.filtersCurrent.options &&
              this.filtersCurrent.options.slice(0, 2).length) ||
              0) +
            ((this.filtersCurrent.autoOptions && this.filtersCurrent.autoOptions.length) || 0);
        }
        return length;
      },
    },
    // gridtable默认属性
    defaultOptions: {
      get() {
        const { getPrefixCls } = this.configProvider;
        const prefixCls = getPrefixCls('', 'fc');
        // / class={`${prefixCls}-filterwrap`}
        return {
          enableCellTextSelection: true, //允许单元格文本被选中。
          rowData: [],
          rowHeight: 40, //设置表格行的高度。
          headerHeight: 40, // 设置表格表头的行高

          overlayLoadingTemplate: '<span class="agGridLoading"></span>', //设置加载状态时的展示模板。
          overlayNoRowsTemplate:
            `<div class="agGridEmpty">` +
            (this.gridOptions.noPermission //!!!!!! 空值展示
              ? `
                <div class="${prefixCls}-noPermission"/>
                <div class="agGridEmpty-text">
                  ${this.gridOptions.noPermission || ''}
                </div>`
              : `
                 <div class="${prefixCls}-noData"/>
                <div class="agGridEmpty-text">
                  ${this.gridOptions.noData || '暂无相关数据'}
                </div>`) +
            `</div>`, // 设置无数据时的展示模板，包括无权限和无数据两种情况
          onColumnResized: e => {
            if (e.finished == true && e.source == 'uiColumnResized' && e.type == 'columnResized') {
              // 获取调整后的列宽
              const resizedColumn = e.column;
              const newWidth = resizedColumn.getActualWidth();
              e.columnApi.setColumnWidth(resizedColumn, newWidth);
              e.api.sizeColumnsToFit(); // 解决拖拽列表，表格左侧会出现空白问题
            }
          }, //处理列调整大小事件，确保表格左侧不会出现空白问题
          onGridReady: e => {
            e.api.sizeColumnsToFit();
            if (this.gridOptions.loading) {
              this.gridOptionsDeal.api.showLoadingOverlay();
            }
            let wrap1 = document.querySelectorAll('.ag-center-cols-viewport');
            wrap1[0].addEventListener('scroll', tableResize, {
              passive: true,
            });
          }, //处理表格准备就绪事件，包括自适应列宽、显示加载状态等操作。
          onGridSizeChanged(e) {
            e.api.sizeColumnsToFit();
          }, //处理表格大小改变事件，自适应列宽。
          onRowClicked(event) {
            let node = event.node;
            let selected = node.isSelected();
            node.setSelected(!selected);
          }, // 处理行点击事件，切换行的选中状态。
          defaultColDef: {
            valueFormatter: params => {
              return params.value ? params.value : '';
            }, //设置默认列定义，包括值格式化函数。
          },
        };
      },
    },
  },

  watch: {
    filters: {
      immediate: true, // 立即执行
      deep: true,
      handler(varl) {
        this.$nextTick(() => {
          this.dealNormalFiltersCss();
          if (varl) {
            this.filtersCurrent = cloneDeep(varl);
          }
        });
      },
    },
    'gridOptions.loading': {
      handler(newVal) {
        if (newVal) {
          this.gridOptionsDeal.api.showLoadingOverlay();
        } else {
          this.gridOptionsDeal.api.hideOverlay();
          if (Array.isArray(this.gridOptions.rowData) && this.gridOptions.rowData.length === 0) {
            this.gridOptionsDeal.api.showNoRowsOverlay();
          } else {
            this.gridOptionsDeal.api.hideOverlay();
          }
        }
      },
    },
    'gridOptions.rowData'(newVal) {
      if (Array.isArray(this.gridOptions.rowData) && this.gridOptions.rowData.length === 0) {
        this.gridOptionsDeal.api.showNoRowsOverlay();
      } else {
        this.gridOptionsDeal.api.hideOverlay();
      }
      this.rowData = newVal;
      //如果新进来数据,同时还是开着跨页全选, 说明继续沿袭逻辑
      if (this.isSelectedAll) {
        this.$nextTick(() => {
          const rowsToDisplay = this.gridOptionsDeal.api.getModel().rowsToDisplay;
          rowsToDisplay.forEach(rowNode => {
            const rowData = rowNode.data;
            if (!this.removeSelected.some(excludedRow => this.isSameRow(rowData, excludedRow))) {
              rowNode.setSelected(true);
            } else {
              rowNode.setSelected(false);
            }
          });
        });
      } else {
        //如果新进来数据,同时关闭了跨页全选,应该默认执行了selectedAll 函数的关闭事件
        this.removeSelected = [];
      }
      this.changeTableChecked();
    },
    'gridOptions.columnDefs'(newVal) {
      this.columnDefs = newVal;
      this.columnDefs.forEach(item => {
        if (item.buttons) {
          item['unSortIcon'] = false;
          item['sortable'] = false;
          item.cellClass = 'fc-table-operation-item';
          item.cellRenderer = params => {
            const container = document.createElement('span');
            item.buttons.forEach(button => {
              if (
                button.show === undefined ||
                (typeof button.show === 'function' && button.show(params))
              ) {
                const spanButton = document.createElement('span');
                if (button.html) {
                  const tooltip = this.$createElement(
                    'a-tooltip',
                    {
                      attrs: {
                        placement: 'top',
                      },
                    },
                    [
                      this.$createElement(
                        'template',
                        {
                          slot: 'title',
                        },
                        [this.$createElement('span', button.title || '')],
                      ),
                      this.$createElement('span', { domProps: { innerHTML: button.html } }),
                    ],
                  );
                  const vm = new Vue({
                    render: h => tooltip,
                  }).$mount(); //
                  if (button.title) {
                    const div = document.createElement('div');
                    div.classList.add('fc-table-all-aggrid-html');
                    div.append(vm.$el);
                    spanButton.append(div);
                  } else {
                    spanButton.innerHTML =
                      '<div class="fc-table-all-aggrid-html">' + button.html + '</div>';
                  }
                }
                if (button.label) {
                  spanButton.textContent = button.label;
                  spanButton.classList.add('fc-table-all-aggrid-operate');
                }
                spanButton.style.color = button.color;
                if (
                  button.disabled === undefined ||
                  button.disabled === false ||
                  (typeof button.disabled === 'function' && !button.disabled(params))
                ) {
                  spanButton.addEventListener('click', event => {
                    this.operate(event, button.handler, params.data);
                    event.stopPropagation();
                  });
                } else {
                  // spanButton.style.color = '#C9CDD4';
                  spanButton.style.opacity = 0.35;
                  spanButton.style.cursor = 'not-allowed';
                }
                // if(item.field === 'operate'){
                //   container.appendChild(spanButton);
                // }else{
                //   if(button.title){
                //     container.appendChild(vm.$el);
                //   }else{
                //     container.appendChild(spanButton);
                //   }
                // }
                container.appendChild(spanButton);
              }
            });
            return container;
          };
        } else {
          if (!item.cellClass) {
            item.cellClass = 'fc-table-all-aggrid-ellispsis';
          } else if (Array.isArray(item.cellClass)) {
            item.cellClass.push('fc-table-all-aggrid-ellispsis');
          } else if (typeof item.cellClass === 'string') {
            item.cellClass = [item.cellClass];
            item.cellClass.push('fc-table-all-aggrid-ellispsis');
          }
          item.tooltipValueGetter ? '' : (item.tooltipField = item.field);
        }
        if (item.isClick) {
          item.cellRenderer = params => {
            const container = document.createElement('span');
            if (typeof item.handler === 'string') {
              const aButton = document.createElement('a');
              aButton.textContent = params.value;
              aButton.style.color = item.color || '';
              aButton.addEventListener('click', event => {
                this.tableButtonClick(event, item.handler, params);
                event.stopPropagation();
              });
              container.appendChild(aButton);
            } else if (Array.isArray(item.handler)) {
            }
            return container;
          };
        }
      });

      this.$nextTick(() => {
        let wrap1 = document.querySelectorAll('.ag-center-cols-viewport');
        // let wrap2 = document.querySelectorAll('.ag-body-viewport');
        tableResize(wrap1[0]);
        wrap1[0].addEventListener('scroll', tableResize, {
          passive: true,
        });
      });
    },
    'gridOptions.selectedAll'(newVal) {
      this.deselectAllPages();
      this.gridOptionsDeal.selectedAll = newVal;
    },
    gridOptions: {
      immediate: true, // 立即执行
      handler(newVal) {
        this.rowData = newVal.rowData;
        this.columnDefs = newVal.columnDefs;
        this.initOptions();
      },
    },
    defaultOptions: {
      immediate: true, // 立即执行
      handler() {
        this.initOptions();
      },
    },
  },

  mounted() {
    this.pageSize = this.pagination.pageSize;
    this.dealCss();
    let wrap1 = document.querySelectorAll('.ag-center-cols-viewport');
    // let wrap2 = document.querySelectorAll('.ag-body-viewport');
    tableResize(wrap1[0]);
    wrap1[0].addEventListener('scroll', tableResize, {
      passive: true,
    });
    this.$nextTick(() => {
      tableResize(wrap1[0]);
    });
    window.addEventListener('resize', this.dealCss);
  },
  beforeDestroy() {
    // 在组件销毁前移除事件监听器，以防止内存泄漏
    window.removeEventListener('resize', this.dealCss);
  },
  methods: {
    /*==============================初始化函数==============================\*/
    initOptions() {
      this.gridOptionsDeal = { ...this.defaultOptions, ...this.gridOptions };
      this.gridOptionsDeal.columnDefs.forEach(item => {
        if (item.buttons) {
          item['unSortIcon'] = false;
          item['sortable'] = false;
          item.cellRenderer = params => {
            const container = document.createElement('span');
            item.buttons.forEach(button => {
              if (
                button.show === undefined ||
                (typeof button.show === 'function' && button.show(params))
              ) {
                const spanButton = document.createElement('span');
                if (button.html) {
                  const tooltip = this.$createElement(
                    'a-tooltip',
                    {
                      attrs: {
                        placement: 'top',
                      },
                    },
                    [
                      this.$createElement(
                        'template',
                        {
                          slot: 'title',
                        },
                        [this.$createElement('span', button.title || '')],
                      ),
                      this.$createElement('span', { domProps: { innerHTML: button.html } }),
                    ],
                  );
                  const vm = new Vue({
                    render: h => tooltip,
                  }).$mount(); //
                  if (button.title) {
                    const div = document.createElement('div');
                    div.classList.add('fc-table-all-aggrid-html');
                    div.append(vm.$el);
                    spanButton.append(div);
                  } else {
                    spanButton.innerHTML =
                      '<div class="fc-table-all-aggrid-html">' + button.html + '</div>';
                  }
                }
                if (button.label) {
                  spanButton.textContent = button.label;
                }
                spanButton.style.color = button.color;
                spanButton.classList.add('fc-table-all-aggrid-operate');
                if (
                  button.disabled === undefined ||
                  button.disabled === false ||
                  (typeof button.disabled === 'function' && !button.disabled(params))
                ) {
                  spanButton.addEventListener('click', event => {
                    this.operate(event, button.handler, params.data);
                    event.stopPropagation();
                  });
                } else {
                  // spanButton.style.color = '#C9CDD4';
                  spanButton.style.opacity = 0.35;
                  spanButton.style.cursor = 'not-allowed';
                }
                // const tooltip = this.$createElement(
                //   'a-tooltip',
                //     {
                //       attrs: {
                //         placement: 'top'
                //       },style: {
                //         float: 'left'
                //       }
                //     },
                //     [
                //       this.$createElement(
                //         'template',
                //         {
                //           slot: 'title'
                //         },
                //         [
                //           this.$createElement('span', button.title || '')
                //         ]
                //       ),
                //       this.$createElement('span', { domProps: { innerHTML: spanButton.outerHTML} })
                //     ]
                // );
                // const vm = new Vue({
                //   render: h => tooltip
                // }).$mount(); //
                container.appendChild(spanButton);
                // if(item.field === 'operate'){
                //   container.appendChild(spanButton);
                // }else{
                //   if(button.title){
                //     container.appendChild(vm.$el);
                //   }else{
                //     container.appendChild(spanButton);
                //   }
                // }
              }
            });
            return container;
          };
        } else {
          if (!item.cellClass) {
            item.cellClass = 'fc-table-all-aggrid-ellispsis';
          } else if (Array.isArray(item.cellClass)) {
            item.cellClass.push('fc-table-all-aggrid-ellispsis');
          } else if (typeof item.cellClass === 'string') {
            item.cellClass = [item.cellClass];
            item.cellClass.push('fc-table-all-aggrid-ellispsis');
          }
          item.tooltipValueGetter ? '' : (item.tooltipField = item.field);
          // item.tooltipField = item.field;
        }
        if (item.isClick) {
          item.cellRenderer = params => {
            const aButton = document.createElement('a');
            aButton.textContent = params.value;
            aButton.style.color = item.color || '';
            aButton.addEventListener('click', event => {
              this.tableButtonClick(event, item.handler, params);
              event.stopPropagation();
            });
            return aButton;
          };
        } else if (item.switch) {
          item.cellRenderer = params => {
            const aButton = document.createElement('a');
            aButton.textContent = params.value;
            aButton.style.color = item.color || '';
            aButton.addEventListener('click', event => {
              this.tableButtonClick(event, item.handler, params);
              event.stopPropagation();
            });
            return aButton;
          };
        }
      });
    },

    dealCss() {
      this.dealNormalFiltersCss();
      this.dealTableShadowCss();
    },
    dealNormalFiltersCss() {
      // normal 情况下 是否显示高级检索
      // 总宽度
      let headersWidth = 0;

      if (document.getElementsByClassName('fc-table-header').length !== 0) {
        headersWidth = document.getElementsByClassName('fc-table-header')[0].clientWidth || 0;
      }
      let formItems = document.getElementsByClassName('fc-table-header-filter-form-item');
      let filtersSum = 0;
      if (formItems.length > 0) {
        for (let i = 0; i < formItems.length; i++) {
          filtersSum += formItems[i].clientWidth || 0;
          filtersSum += 16;
        }
      }

      if (!this.filters.options || this.filters.options.length === 0) {
        this.isRetract = false;
      } else if (headersWidth > filtersSum) {
        this.isRetract = false;
      } else {
        this.isRetract = true;
      }
    },
    // 给table 加阴影
    dealTableShadowCss() {
      let wrap1 = document.querySelectorAll('.ag-center-cols-viewport');
      // let wrap2 = document.querySelectorAll('.ag-body-viewport');
      tableResize(wrap1[0]);
      wrap1[0].addEventListener('scroll', tableResize, {
        passive: true,
      });
      this.$nextTick(() => {
        tableResize(wrap1[0]);
      });
    },
    /*==============================初始化函数- watch函数==============================\*/
    // render特定字段点击事件
    tableButtonClick(event, methodName, params) {
      let row = params.data;
      this.$emit('click', event, methodName, row);
    },

    // 表格操作按钮
    operate(event, handler, row) {
      this.$emit('click', event, handler, row);
    },
    // 检查两行数据是否相同
    isSameRow(rowData1, rowData2) {
      const { previouslySelected: _, ...cleanedRowData1 } = rowData1;
      const { previouslySelected: __, ...cleanedRowData2 } = rowData2;
      return JSON.stringify(cleanedRowData1) === JSON.stringify(cleanedRowData2);
    },
    /*==============================事件函数==============================\*/
    /**
     * 树节点展开方法回调
     * @param {*} item
     */
    treeExpand(item) {
      this.$nextTick(() => {
        this.$emit('treeExpand', item);
      });
    },

    onSelectionChanged(event) {
      if (this.isSelectedAll) {
        // 对每个节点进行进一步处理
        event.api.forEachNodeAfterFilterAndSort(node => {
          const isSelected = node.isSelected();
          const previouslySelected = node.data.previouslySelected || false; // 之前是否被选中
          if (isSelected && !previouslySelected) {
            // 重新选中时移除
            this.removeSelected = this.removeSelected.filter(
              item => JSON.stringify(item) !== JSON.stringify(node.data),
            );
          } else if (!isSelected && previouslySelected) {
            // 判断是否重复添加 重复则不push
            let hasSame = this.removeSelected.some(
              item => JSON.stringify(item) === JSON.stringify(node.data),
            );
            if (!hasSame) {
              this.removeSelected.push(node.data);
            }
          }
          node.data.previouslySelected = isSelected; // 更新之前的选中状态
        });
      }
      this.changeTableChecked();
    },

    changeTableChecked() {
      let rows = this.gridOptionsDeal.api.getSelectedRows();
      // 功能1------------更新当前已选择条数
      this.tableChecked = rows.length;
      // 功能2------------触发父组件事件,更新已选择条数
      if (this.isSelectedAll) {
        // 跨页全选的时候,条数来自于未勾选的行
        this.$nextTick(() => {
          this.$emit('getSelectedRows', this.removeSelected, 'remove');
        });
      } else {
        this.$emit('getSelectedRows', rows, 'selected');
      }
    },
    // pagination页码，pagesize变化
    changePage(current, pageSize) {
      this.pagination.current = current || 1;
      this.pagination.currentPage = current || 1;
      this.pageSize = pageSize;
      this.$emit('change', {}, this.pagination.current, pageSize);
    },
    // 筛选条件变化
    // event 事件对象/item 筛选数据对象
    filterChange(event, item, form) {
      // 存在多个相同事件会事件死循环 做一个合并处理
      if (item && item.change) {
        item.change(event, item, form);
      }
      // 根据新的一体化规范需要做出优化，两个和一个的时候触发，两个以上不能触发，需要使用按钮进行触发
      this.filtersCurrentShowLength < 3 &&
        this.$nextTick(() => {
          this.$emit('change', event || {}, this.current, this.pageSize);
        });
    },
    linkChange(e, item, form) {
      if (item && item.change) {
        item.change(e, item, form);
      }
    },
    // 筛选器操作按钮点击
    btnClick(event, buttonHandle, isValidate) {
      // isValidate：是否校验
      if (isValidate) {
        this.handleSubmit();
      }
      this.$emit('click', event, buttonHandle);
    },
    // 重置
    resetClick(event) {
      this.form.resetFields();
      this.$emit('click', event, 'reset');
      this.filtersCurrent = cloneDeep(this.filters);
    },
    // 筛选器操作按钮点击-->校验
    handleSubmit() {
      this.form.validateFields((err, values) => {
        if (!err) {
          const handleErrors = options => {
            options &&
              options.forEach(item => {
                item.validateStatus = '';
                item.help = '';
              });
          };
          if (this.filtersCurrent.mode === undefined || this.filtersCurrent.mode === 'normal') {
            handleErrors(this.filtersCurrent.options);
          } else if (this.filtersCurrent.mode === 'auto') {
            handleErrors(this.filtersCurrent.options);
            handleErrors(this.filtersCurrent.autoOptions);
          }
          this.$emit('getFilters', values);
        } else {
          const errKeys = Object.keys(err) || [];
          const uniqueArr = arr => arr.filter((item, index) => arr.indexOf(item) === index);

          const handleErrors = options => {
            options &&
              options.forEach(item => {
                if (errKeys.indexOf(item.field) !== -1) {
                  item.validateStatus = 'error';
                  item.help = uniqueArr(err[item.field].values.map(i => i.errors[0].message)).join(
                    ';',
                  );
                }
              });
          };

          if (this.filtersCurrent.mode === undefined || this.filtersCurrent.mode === 'normal') {
            handleErrors(this.filtersCurrent.options);
          } else if (this.filtersCurrent.mode === 'auto') {
            handleErrors(this.filtersCurrent.options);
            handleErrors(this.filtersCurrent.autoOptions);
          }
        }
      });
    },
    //跨页全选
    selectedAll(e) {
      if (e.target.checked) {
        this.isSelectedAll = true;
        this.gridOptionsDeal.api.selectAll();
      } else {
        this.isSelectedAll = false;
        this.gridOptionsDeal.api.deselectAll();
        this.removeSelected = [];
      }
    },

    // 重置所有筛选
    deselectAllPages() {
      this.isSelectedAll = false;
      this.gridOptionsDeal.api.deselectAll();
    },
    // 高级搜索展开
    toggleAll(target) {
      if (this.filtersCurrent.mode === undefined || this.filtersCurrent.mode === 'normal') {
        this.toggle(target);
      }
      if (this.filtersCurrent.mode === 'auto') {
        this.advancedToggle(target);
      }
    },
    toggle(target) {
      this.retract = typeof target === 'boolean' ? target : !this.retract;
      let filters = document.getElementsByClassName('fc-table-header-filter-form')[0];
      if (!this.retract) {
        filters.style.height = '33px';
        filters.style.marginBottom = '16px';
      } else {
        filters.style.height = 'auto';
        filters.style.marginBottom = '0';
      }
    },
    advancedToggle(target) {
      this.isAdvance = typeof target === 'boolean' ? target : !this.isAdvance;
    },

    /*==============================ref函数 供父组件调用==============================\*/
    // 重置顶部筛选条件
    reset() {
      this.form.resetFields();
    },
    // 获取查询条件所有的参数
    getFilters() {
      function handleValue(value) {
        if (value === null || value === undefined) {
          return '';
        } else {
          return value;
        }
      }

      return new Promise((resolve, reject) => {
        this.form.validateFields((err, valuesRes) => {
          if (!err) {
            for (const key in valuesRes) {
              let value = valuesRes[key];
              if (typeof value === 'object' && value !== null) {
                if (
                  value.linkageType !== undefined &&
                  (value.values !== undefined || value.value !== undefined)
                ) {
                  // 对特定结构对象中的字符串去除首尾空格
                  if (value.values)
                    value.values = value.values.map(val =>
                      typeof val === 'string' ? val.trim() : handleValue(val),
                    );
                  if (value.value)
                    value.value =
                      typeof value.value === 'string'
                        ? value.value.trim()
                        : handleValue(value.value);
                } else if (Array.isArray(value)) {
                  // 对数组中的字符串去除首尾空格
                  value = value.map(val =>
                    typeof val === 'string' ? val.trim() : handleValue(val),
                  );
                }
              } else if (typeof value === 'string') {
                // 对字符串去除首尾空格
                value = value.trim();
              } else {
                value = handleValue(value);
              }
              valuesRes[key] = value;
            }
            resolve(valuesRes);
          } else {
            resolve(false);
          }
        });
      });
    },
    // 获取所有筛选条件
    gridOptionsConfig() {
      return this.gridOptionsDeal;
    },

    /*
    ==============================模板函数==============================

    */
    isRowSelectable(params) {
      if (this.gridOptions.isRowSelectable) {
        return this.gridOptions.isRowSelectable(params);
      } else {
        return true;
      }
    },
    getFormItemHeight(filters) {
      let totalLength = 0;

      filters.autoOptions.forEach(option => {
        if (option.linkage) {
          totalLength += 2;
        } else {
          totalLength++;
        }
      });
      return `${totalLength % 4 === 0 ? 8 : 29}px`;
    },
    renderBtns(prefixCls, buttons, className) {
      return buttons.map((item, index) => {
        if (
          item.dropDown &&
          item.dropDown.options &&
          Array.isArray(item.dropDown.options) &&
          item.dropDown.options.length > 0
        ) {
          if (item.show || item.show === undefined) {
            if (item.tooltip) {
              return (
                <a-tooltip {...{ props: item.tooltip.props }}>
                  <template slot="title">
                    <span>{item.tooltip.text}</span>
                  </template>
                  <a-dropdown>
                    <a-menu
                      slot="overlay"
                      onClick={event => this.btnClick(event, event.key, item.isValidate)}
                    >
                      {item.dropDown.options.map(
                        (menuItem, index) =>
                          (menuItem.show || menuItem.show === undefined) && (
                            <a-menu-item key={menuItem.handler} {...{ props: menuItem }}>
                              {menuItem.text}
                            </a-menu-item>
                          ),
                      )}
                    </a-menu>
                    <a-button
                      {...{ props: item }}
                      class={`${prefixCls}-header-buttons-${className}-wrap-button ${prefixCls}-button`}
                      onClick={event => this.btnClick(event, item.handler, item.isValidate)}
                    >
                      {item.icon && (
                        <fc-icon
                          className={item.icon}
                          size={`${
                            !item.size
                              ? '15px'
                              : item.size === 'small'
                              ? '12px'
                              : item.size === 'large'
                              ? '16px'
                              : '15px'
                          }`}
                          color={item.iconColor ? item.iconColor : 'inherit'}
                          style={{ marginLeft: 0, marginRight: '8px', lineHeight: '16px' }}
                        ></fc-icon>
                      )}
                      {item.text}
                      <a-icon type="down" />
                    </a-button>
                  </a-dropdown>
                </a-tooltip>
              );
            } else {
              return (
                <a-dropdown>
                  <a-menu
                    slot="overlay"
                    onClick={event => this.btnClick(event, event.key, item.isValidate)}
                  >
                    {item.dropDown.options.map(
                      (menuItem, index) =>
                        (menuItem.show || menuItem.show === undefined) && (
                          <a-menu-item key={menuItem.handler} {...{ props: menuItem }}>
                            {menuItem.text}
                          </a-menu-item>
                        ),
                    )}
                  </a-menu>
                  <a-button
                    {...{ props: item }}
                    class={`${prefixCls}-header-buttons-${className}-wrap-button ${prefixCls}-button   ${
                      item.icon && !item.text ? 'icon-btn' : ''
                    }`}
                    onClick={event => this.btnClick(event, item.handler, item.isValidate)}
                  >
                    {item.icon && (
                      <fc-icon
                        className={item.icon}
                        size={`${
                          !item.size
                            ? '15px'
                            : item.size === 'small'
                            ? '12px'
                            : item.size === 'large'
                            ? '16px'
                            : '15px'
                        }`}
                        color={item.iconColor ? item.iconColor : 'inherit'}
                        style={{ marginLeft: 0, marginRight: '8px', lineHeight: '16px' }}
                      ></fc-icon>
                    )}
                    {item.text}
                    <a-icon type="down" />
                  </a-button>
                </a-dropdown>
              );
            }
          } else {
            return null;
          }
        } else if (item.upload && item.upload.props && item.upload.on) {
          if (item.show || item.show === undefined) {
            if (item.tooltip) {
              return (
                <a-tooltip {...{ props: item.tooltip.props }}>
                  <template slot="title">
                    <span>{item.tooltip.text}</span>
                  </template>
                  <fc-upload
                    {...{ props: item.upload.props }}
                    {...{ on: item.upload.on }}
                    class={`${prefixCls}-header-buttons-${className}-wrap-button ${prefixCls}-button`}
                  >
                    <template slot="content">
                      <a-button
                        {...{ props: item }}
                        class={`${item.icon && !item.text ? 'icon-btn' : ''}`}
                      >
                        {item.icon && (
                          <fc-icon
                            className={item.icon}
                            size={`${
                              !item.size
                                ? '15px'
                                : item.size === 'small'
                                ? '12px'
                                : item.size === 'large'
                                ? '16px'
                                : '15px'
                            }`}
                            color={item.iconColor ? item.iconColor : 'inherit'}
                            style={{ marginLeft: 0, marginRight: '8px', lineHeight: '16px' }}
                          ></fc-icon>
                        )}
                        {item.text}
                        {item.tooltip.icon && (
                          <fc-icon
                            className="FCquestion"
                            size={`${
                              !item.size
                                ? '15px'
                                : item.size === 'small'
                                ? '12px'
                                : item.size === 'large'
                                ? '16px'
                                : '15px'
                            }`}
                            color={item.iconColor ? item.iconColor : 'inherit'}
                            style={{ marginLeft: '8px', marginRight: 0, lineHeight: '16px' }}
                          ></fc-icon>
                        )}
                      </a-button>
                    </template>
                  </fc-upload>
                </a-tooltip>
              );
            } else {
              return (
                <fc-upload
                  {...{ props: item.upload.props }}
                  {...{ on: item.upload.on }}
                  class={`${prefixCls}-header-buttons-${className}-wrap-button ${prefixCls}-button ${
                    item.icon && !item.text ? 'icon-btn' : ''
                  }`}
                >
                  <template slot="content">
                    <a-button {...{ props: item }}>
                      {item.icon && (
                        <fc-icon
                          className={item.icon}
                          size={`${
                            !item.size
                              ? '15px'
                              : item.size === 'small'
                              ? '12px'
                              : item.size === 'large'
                              ? '16px'
                              : '15px'
                          }`}
                          color={item.iconColor ? item.iconColor : 'inherit'}
                          style={{ marginLeft: 0, marginRight: '8px', lineHeight: '16px' }}
                        ></fc-icon>
                      )}
                      {item.text}
                    </a-button>
                  </template>
                </fc-upload>
              );
            }
          } else {
            return null;
          }
        } else if (item.tooltip) {
          if (item.show || item.show === undefined) {
            return (
              <a-tooltip {...{ props: item.tooltip.props }}>
                <template slot="title">
                  <span>{item.tooltip.text}</span>
                </template>
                <a-button
                  {...{ props: item }}
                  class={`${prefixCls}-header-buttons-${className}-wrap-button ${prefixCls}-button ${
                    item.icon && !item.text ? 'icon-btn' : ''
                  }`}
                  onClick={event => this.btnClick(event, item.handler, item.isValidate)}
                >
                  {item.icon && (
                    <fc-icon
                      className={item.icon}
                      size={`${
                        !item.size
                          ? '15px'
                          : item.size === 'small'
                          ? '12px'
                          : item.size === 'large'
                          ? '16px'
                          : '15px'
                      }`}
                      color={item.iconColor ? item.iconColor : 'inherit'}
                      style={{ marginLeft: 0, marginRight: '8px', lineHeight: '16px' }}
                    ></fc-icon>
                  )}
                  {item.text}
                  {item.tooltip.icon && (
                    <fc-icon
                      className="FCquestion"
                      size={`${
                        !item.size
                          ? '15px'
                          : item.size === 'small'
                          ? '12px'
                          : item.size === 'large'
                          ? '16px'
                          : '15px'
                      }`}
                      color={item.iconColor ? item.iconColor : 'inherit'}
                      style={{ marginLeft: '8px', marginRight: 0, lineHeight: '16px' }}
                    ></fc-icon>
                  )}
                </a-button>
              </a-tooltip>
            );
          } else {
            return null;
          }
        } else {
          return (
            (item.show || item.show === undefined) && (
              // 编研车的数量需求 -- 外套一层badge
              <a-badge
                count={
                  typeof item.count === 'number' ? (!Number.isNaN(item.count) ? item.count : 0) : 0
                }
                numberStyle={{ backgroundColor: '#175DFF' }}
                class={`${prefixCls}-header-buttons-${className}-wrap-button ${prefixCls}-button`}
              >
                <a-button
                  {...{ props: item }}
                  class={`${prefixCls}-header-buttons-${className}-wrap-button ${prefixCls}-button`}
                  onClick={event => this.btnClick(event, item.handler, item.isValidate)}
                >
                  {item.icon && (
                    <fc-icon
                      className={item.icon}
                      size={`${
                        !item.size
                          ? '15px'
                          : item.size === 'small'
                          ? '12px'
                          : item.size === 'large'
                          ? '16px'
                          : '15px'
                      }`}
                      color={item.iconColor ? item.iconColor : 'inherit'}
                      style={{ marginLeft: 0, marginRight: '8px', lineHeight: '16px' }}
                    ></fc-icon>
                  )}
                  {item.text}
                </a-button>
              </a-badge>
            )
          );
        }
      });
    },
    // 多选类型的筛选!!!
    renderLinkage(item) {
      const { getPrefixCls } = this.configProvider;
      const prefixCls = getPrefixCls('', 'fc-table');
      if (!item.isChange && item.defaultLinkage) {
        item.currentLinkageType = item.defaultLinkage; //currentLinkageType 属性的作用是告诉页面 -- 哪个属性是需要两个select/input 显示的
      }
      if (
        item.range &&
        item.range.indexOf(item.currentLinkageType) !== -1 &&
        item.type === 'input'
      ) {
        return (
          <span>
            <a-col span="8">
              <a-input
                class={`${prefixCls}-filterwrap`}
                {...{ props: item }}
                {...{ on: omit(item, 'pressEnter', 'change') }}
                v-decorator={[
                  item.field + '[values][0]',
                  {
                    rules: item.rules,
                    initialValue: item.defaultValue ? item.defaultValue[0] : undefined,
                  },
                ]}
                onPressEnter={$event => {
                  this.filterChange($event, item, this.form);
                }}
                onChange={e => {
                  this.linkChange(e, item, this.form);
                }}
                style={item.style || ''}
              ></a-input>
            </a-col>
            <a-col span="8">
              <a-input
                class={`${prefixCls}-filterwrap`}
                {...{ props: item }}
                {...{ on: omit(item, 'pressEnter', 'change') }}
                v-decorator={[
                  item.field + '[values][1]',
                  {
                    rules: item.rules,
                    initialValue: item.defaultValue ? item.defaultValue[1] : undefined,
                  },
                ]}
                onPressEnter={$event => {
                  this.filterChange($event, item);
                }}
                onChange={e => {
                  this.linkChange(e, item, this.form);
                }}
                style={item.style || ''}
              ></a-input>
            </a-col>
          </span>
        );
      } else if (
        (item.range && item.range.indexOf(item.currentLinkageType)) !== -1 &&
        item.type === 'select'
      ) {
        return (
          <span>
            <a-col span="8">
              <a-select
                class={`${prefixCls}-filter`}
                {...{ props: item }}
                {...{ on: omit(item, 'change') }}
                v-decorator={[
                  item.field + '[values][0]',
                  {
                    rules: item.rules,
                    initialValue: item.defaultValue ? item.defaultValue[0] : undefined,
                  },
                ]}
                notFoundContent={<span class="ant-select-not-found"></span>}
                onChange={e => {
                  this.filterChange(e, item, this.form);
                }}
                style={item.style || ''}
              >
                {item.options.map((option, index) => {
                  return (
                    <a-select-option key={index} value={option.value}>
                      {option.label}
                    </a-select-option>
                  );
                })}
              </a-select>
            </a-col>
            <a-col span="8">
              <a-select
                class={`${prefixCls}-filter`}
                {...{ props: item }}
                {...{ on: omit(item, 'change') }}
                v-decorator={[
                  item.field + '[values][1]',
                  {
                    rules: item.rules,
                    initialValue: item.defaultValue ? item.defaultValue[1] : undefined,
                  },
                ]}
                notFoundContent={<span class="ant-select-not-found"></span>}
                onChange={e => {
                  this.filterChange(e, item, this.form);
                }}
                style={item.style || ''}
              >
                {item.options.map((option, index) => {
                  return (
                    <a-select-option key={index} value={option.value}>
                      {option.label}
                    </a-select-option>
                  );
                })}
              </a-select>
            </a-col>
          </span>
        );
      } else if (
        (item.range && item.range.indexOf(item.currentLinkageType)) !== -1 &&
        item.type === 'date'
      ) {
        return (
          <span>
            <a-col span="16">
              <a-range-picker
                class={`${prefixCls}-filter`}
                {...{ props: item }}
                {...{ on: omit(item, 'change') }}
                v-decorator={[
                  item.field + '[values]',
                  {
                    rules: item.rules,
                    initialValue: item.defaultValue
                      ? [item.defaultValue[0], item.defaultValue[1]]
                      : undefined,
                  },
                ]}
                onChange={e => {
                  this.filterChange(e, item);
                }}
                placeholder={item.placeholder || ['开始时间', '结束时间']}
                style={item.style || { width: '100%' }}
              />
            </a-col>
          </span>
        );
      } else if (
        ((item.range && item.range.indexOf(item.currentLinkageType)) === -1 || !item.range) &&
        item.type === 'input'
      ) {
        return (
          <a-col span="16">
            <a-input
              class={`${prefixCls}-filterwrap`}
              {...{ props: item }}
              {...{ on: omit(item, 'pressEnter', 'change') }}
              v-decorator={[
                item.field + '[value]',
                { rules: item.rules, initialValue: item.defaultValue },
              ]}
              onPressEnter={$event => {
                this.filterChange($event, item);
              }}
              onChange={e => {
                this.linkChange(e, item, this.form);
              }}
              style={item.style || ''}
            ></a-input>
          </a-col>
        );
      } else if (
        ((item.range && item.range.indexOf(item.currentLinkageType)) === -1 || !item.range) &&
        item.type === 'select'
      ) {
        return (
          <a-col span="16">
            <a-select
              class={`${prefixCls}-filter`}
              {...{ props: item }}
              {...{ on: omit(item, 'change') }}
              v-decorator={[
                item.field + '[value]',
                { rules: item.rules, initialValue: item.defaultValue },
              ]}
              onChange={value => {
                this.filterChange({}, item);
              }}
              style={item.style || ''}
              notFoundContent={<span class="ant-select-not-found"></span>}
            >
              {item.options.map((option, index) => {
                return (
                  <a-select-option key={index} value={option.value}>
                    {option.label}
                  </a-select-option>
                );
              })}
            </a-select>
          </a-col>
        );
      } else if (
        ((item.range && item.range.indexOf(item.currentLinkageType)) === -1 || !item.range) &&
        item.type === 'date'
      ) {
        return (
          <a-col span="16">
            <a-date-picker
              class={`${prefixCls}-filter`}
              {...{ props: item }}
              {...{ on: omit(item, 'change') }}
              v-decorator={[
                item.field + '[value]',
                { rules: item.rules, initialValue: item.defaultValue },
              ]}
              onChange={e => {
                this.filterChange(e, item);
              }}
              placeholder={item.placeholder || '请选择'}
              style={item.style || ''}
            />
          </a-col>
        );
      }
    },
  },

  render() {
    const {
      buttons,
      // filters,
      filtersCurrent,
      pagination,
      form,
      gridOptionsDeal,
      rowData,
      tableChecked,
      columnDefs,
      isRetract,
      retract,
      _props,
      $slots,
    } = this;

    const { style } = _props;
    const { getPrefixCls, locale } = this.configProvider;
    const prefixCls = getPrefixCls('', 'fc-table');
    // 水平模式下左侧按钮
    const leftBtns = [];
    // 水平模式下右侧按钮
    const rightBtns = [];
    // 查询条件下方左侧按钮
    const filtersBottomLeft = [];
    // 查询条件下方右侧按钮
    const filtersBottomRight = [];
    // 表格左下角按钮
    const bottomButtons = [];
    // 查询条件同行按钮
    const autoLeft = [];
    // 查询条件同行右侧按钮
    const autoRight = [];
    buttons.options &&
      buttons.options.forEach(button => {
        if (button.position === 'left' && button.show != false) {
          leftBtns.push(button);
        } else if (button.position === 'right' && button.show != false) {
          rightBtns.push(button);
        } else if (button.position === 'filtersBottomLeft' && button.show != false) {
          filtersBottomLeft.push(button);
        } else if (button.position === 'filtersBottomRight' && button.show != false) {
          filtersBottomRight.push(button);
        } else if (button.position === 'bottom' && button.show != false) {
          bottomButtons.push(button);
        } else if (button.position === 'autoLeft' && button.show != false) {
          autoLeft.push(button);
        } else if (button.position === 'autoRight' && button.show != false) {
          autoRight.push(button);
        }
      });

    return (
      <div class={prefixCls} style={style}>
        {/* 筛选器 */}
        {!$slots.header &&
          (leftBtns.length !== 0 ||
            rightBtns.length !== 0 ||
            filtersBottomLeft.length !== 0 ||
            filtersBottomRight.length !== 0 ||
            bottomButtons.length !== 0 ||
            autoLeft.length !== 0 ||
            autoRight.length !== 0 ||
            filtersBottomLeft.length !== 0 ||
            filtersBottomRight.length !== 0 ||
            (filtersCurrent.options && filtersCurrent.options.length !== 0) ||
            (filtersCurrent.autoOptions && filtersCurrent.autoOptions.length !== 0)) && (
            <div class={`${prefixCls}-header`}>
              {/* 按钮部分1 ------- 行1*/}

              {buttons.type === 'horizontal' && (leftBtns.length > 0 || rightBtns.length > 0) && (
                <div class={`${prefixCls}-header-buttonsWrap`}>
                  <div class={`${prefixCls}-header-buttons`}>
                    <div class={`${prefixCls}-header-buttons-leftbtn`}>
                      {this.renderBtns(prefixCls, leftBtns, 'leftbtn')}
                    </div>
                    <div class={`${prefixCls}-header-buttons-rightbtn`}>
                      {this.renderBtns(prefixCls, rightBtns, 'rightbtn')}
                    </div>
                  </div>
                </div>
              )}

              {/* 按钮部分1 -------结束*/}

              {/* 显示模式1--------------- */}
              {(filtersCurrent.mode === undefined || filtersCurrent.mode === 'normal') &&
                filtersCurrent.options &&
                filtersCurrent.options.length > 0 && (
                  // 行2---------------
                  <div class={`${prefixCls}-header-filter`}>
                    <div class={`${prefixCls}-header-filter-form`}>
                      <a-form
                        layout="inline"
                        form={form}
                        label-col={filtersCurrent.labelCol || { span: 6 }}
                        wrapper-col={filtersCurrent.wrapperCol || { span: 18 }}
                      >
                        {filtersCurrent.options.map((item, index) => {
                          if (item.type === 'input' && (item.show === undefined || item.show)) {
                            return (
                              <a-form-item
                                class={`${prefixCls}-header-filter-form-item`}
                                label={item.label ? item.label : null}
                                colon={false}
                                validateStatus={item.validateStatus || ''}
                                help={item.help || ''}
                                labelAlign={filtersCurrent.labelAlign || 'left'}
                                style={filtersCurrent.formItemStyle || ''}
                              >
                                <a-input
                                  class={`${prefixCls}-filter`}
                                  {...{ props: item }}
                                  {...{ on: omit(item, 'pressEnter', 'change') }}
                                  v-decorator={[
                                    item.field,
                                    { rules: item.rules, initialValue: item.defaultValue },
                                  ]}
                                  onPressEnter={$event => {
                                    this.filterChange($event, item);
                                  }}
                                  style={item.style || ''}
                                ></a-input>
                              </a-form-item>
                            );
                          } else if (
                            item.type === 'select' &&
                            (item.show === undefined || item.show)
                          ) {
                            return (
                              <a-form-item
                                class={`${prefixCls}-header-filter-form-item`}
                                label={item.label ? item.label : null}
                                colon={false}
                                validateStatus={item.validateStatus || ''}
                                help={item.help || ''}
                                labelAlign={filtersCurrent.labelAlign || 'left'}
                                style={filtersCurrent.formItemStyle || ''}
                              >
                                <a-select
                                  class={`${prefixCls}-filter`}
                                  {...{ props: item }}
                                  {...{ on: omit(item, 'change') }}
                                  v-decorator={[
                                    item.field,
                                    { rules: item.rules, initialValue: item.defaultValue },
                                  ]}
                                  notFoundContent={<span class="ant-select-not-found"></span>}
                                  style={item.style || ''}
                                >
                                  {item.options.map((option, index) => {
                                    return (
                                      <a-select-option key={index} value={option.value}>
                                        {option.label}
                                      </a-select-option>
                                    );
                                  })}
                                </a-select>
                              </a-form-item>
                            );
                          } else if (
                            item.type === 'treeSelect' &&
                            (item.show === undefined || item.show)
                          ) {
                            return (
                              <a-form-item
                                class={`${prefixCls}-header-filter-form-item`}
                                label={item.label ? item.label : null}
                                colon={false}
                                validateStatus={item.validateStatus || ''}
                                help={item.help || ''}
                                labelAlign={filtersCurrent.labelAlign || 'left'}
                                style={filtersCurrent.formItemStyle || ''}
                              >
                                <a-tree-select
                                  class={`${prefixCls}-filter`}
                                  {...{ props: omit(item, 'treeData') }}
                                  {...{ on: omit(item, 'change') }}
                                  tree-data={item.treeData}
                                  v-decorator={[
                                    item.field,
                                    { rules: item.rules, initialValue: item.defaultValue },
                                  ]}
                                  onChange={value => {
                                    this.filterChange({}, item);
                                  }}
                                  treeExpand={value => {
                                    this.treeExpand(item);
                                  }}
                                  style={item.style || ''}
                                />
                              </a-form-item>
                            );
                          } else if (
                            item.type === 'date' &&
                            (item.show === undefined || item.show)
                          ) {
                            return (
                              <a-form-item
                                class={`${prefixCls}-header-filter-form-item`}
                                label={item.label ? item.label : null}
                                colon={false}
                                validateStatus={item.validateStatus || ''}
                                help={item.help || ''}
                                labelAlign={filtersCurrent.labelAlign || 'left'}
                                style={filtersCurrent.formItemStyle || ''}
                              >
                                <a-range-picker
                                  class={`${prefixCls}-filter`}
                                  {...{ props: item }}
                                  {...{ on: omit(item, 'change') }}
                                  v-decorator={[
                                    item.field,
                                    { rules: item.rules, initialValue: item.defaultValue },
                                  ]}
                                  onChange={e => {
                                    this.filterChange(e, item);
                                  }}
                                  placeholder={item.placeholder || ['开始时间', '结束时间']}
                                  style={item.style || { width: '100%' }}
                                />
                              </a-form-item>
                            );
                          }
                        })}
                      </a-form>
                    </div>
                    {/* 高级搜索按钮 展开按钮位置(普通和aoto 模式 各有一个) */}
                    {isRetract && (
                      <div class={`${prefixCls}-header-filter-expand`}>
                        <span
                          class={`${prefixCls}-header-filter-expand-span`}
                          onClick={() => this.toggleAll()}
                        >
                          {!retract
                            ? filtersCurrent.toggleText && filtersCurrent.toggleText[0]
                              ? filtersCurrent.toggleText[0]
                              : locale.Table.expend
                            : filtersCurrent.toggleText && filtersCurrent.toggleText[1]
                            ? filtersCurrent.toggleText[1]
                            : locale.Table.collapse}
                          {!retract && <a-icon type="caret-down" />}
                          {retract && <a-icon type="caret-up" />}
                        </span>
                      </div>
                    )}
                  </div>
                  // 行2---------------结束
                )}
              {/* 显示模式1---------------结束 */}
              {/* 显示模式2---------------*/}
              {filtersCurrent.mode === 'auto' &&
                (autoLeft.length > 0 ||
                  autoRight.length > 0 ||
                  (filtersCurrent.options && filtersCurrent.options.length > 0) ||
                  (filtersCurrent.autoOptions && filtersCurrent.autoOptions.length > 0)) && (
                  <a-form
                    layout="inline"
                    form={form}
                    label-col={filtersCurrent.labelCol || { span: 8 }}
                    wrapper-col={filtersCurrent.wrapperCol || { span: 16 }}
                  >
                    {/* 行2--------------- */}
                    <div
                      class={`${prefixCls}-header-filterwrap ${
                        this.isAdvance ? `${prefixCls}-header-filterwrap-form-space` : ''
                      }`}
                    >
                      {/* 按钮部分2 -------*/}
                      {buttons.type === 'horizontal' && autoLeft.length > 0 && (
                        <div class={`${prefixCls}-header-filterwrap-buttons`}>
                          <div class={`${prefixCls}-header-filterwrap-all-buttons`}>
                            <div class={`${prefixCls}-header-buttons-leftbtn`}>
                              {this.renderBtns(prefixCls, autoLeft, 'leftbtn')}
                            </div>
                          </div>
                        </div>
                      )}
                      {/* 按钮部分2 -------结束*/}

                      <div class={`${prefixCls}-header-filterwrap-form-operate`}>
                        {/* 显示模式2.1--------------- */}
                        {$slots.forms && (
                          <div class={`${prefixCls}-header-filterwrap-form-slot`}>
                            {$slots.forms}
                          </div>
                        )}
                        {/* 显示模式2.1--------------- 结束*/}
                        {/* 显示模式2.2--------------- */}
                        {!$slots.forms &&
                          filtersCurrent.options &&
                          filtersCurrent.options.length > 0 && (
                            <div
                              class={`${prefixCls}-header-filterwrap-form ${
                                this.isAdvance ? '' : ''
                              }`}
                            >
                              <div>
                                {filtersCurrent.options.slice(0, 2).map((item, index) => {
                                  if (
                                    item.type === 'input' &&
                                    (item.show === undefined || item.show)
                                  ) {
                                    return (
                                      <a-form-item
                                        class={`${prefixCls}-header-filterwrap-form-item`}
                                        label={item.label ? item.label : null}
                                        colon={false}
                                        validateStatus={item.validateStatus || ''}
                                        help={item.help || ''}
                                        labelAlign={filtersCurrent.labelAlign || 'right'}
                                        style={filtersCurrent.formItemStyle || ''}
                                      >
                                        <a-input
                                          class={`${prefixCls}-filterwrap`}
                                          {...{ props: item }}
                                          {...{ on: omit(item, 'pressEnter', 'change') }}
                                          v-decorator={[
                                            item.field,
                                            { rules: item.rules, initialValue: item.defaultValue },
                                          ]}
                                          onPressEnter={$event => {
                                            this.filterChange($event, item);
                                          }}
                                          style={item.style || ''}
                                        ></a-input>
                                      </a-form-item>
                                    );
                                  } else if (
                                    item.type === 'select' &&
                                    (item.show === undefined || item.show)
                                  ) {
                                    return (
                                      <a-form-item
                                        class={`${prefixCls}-header-filterwrap-form-item`}
                                        label={item.label ? item.label : null}
                                        colon={false}
                                        validateStatus={item.validateStatus || ''}
                                        help={item.help || ''}
                                        labelAlign={filtersCurrent.labelAlign || 'right'}
                                        style={filtersCurrent.formItemStyle || ''}
                                      >
                                        <a-select
                                          class={`${prefixCls}-filterwrap`}
                                          {...{ props: item }}
                                          {...{ on: omit(item, 'change') }}
                                          v-decorator={[
                                            item.field,
                                            { rules: item.rules, initialValue: item.defaultValue },
                                          ]}
                                          notFoundContent={
                                            <span class="ant-select-not-found"></span>
                                          }
                                          onChange={value => this.filterChange({}, item)}
                                          style={item.style || ''}
                                        >
                                          {item.options.map((option, index) => {
                                            return (
                                              <a-select-option key={index} value={option.value}>
                                                {option.label}
                                              </a-select-option>
                                            );
                                          })}
                                        </a-select>
                                      </a-form-item>
                                    );
                                  } else if (
                                    item.type === 'treeSelect' &&
                                    (item.show === undefined || item.show)
                                  ) {
                                    return (
                                      <a-form-item
                                        class={`${prefixCls}-header-filterwrap-form-item`}
                                        label={item.label ? item.label : null}
                                        colon={false}
                                        validateStatus={item.validateStatus || ''}
                                        help={item.help || ''}
                                        labelAlign={filtersCurrent.labelAlign || 'right'}
                                        style={filtersCurrent.formItemStyle || ''}
                                      >
                                        <a-tree-select
                                          class={`${prefixCls}-filterwrap`}
                                          {...{ props: omit(item, 'treeData') }}
                                          {...{ on: omit(item, 'change') }}
                                          tree-data={item.treeData}
                                          v-decorator={[
                                            item.field,
                                            { rules: item.rules, initialValue: item.defaultValue },
                                          ]}
                                          onChange={value => {
                                            this.filterChange({}, item);
                                          }}
                                          style={item.style || ''}
                                        />
                                      </a-form-item>
                                    );
                                  } else if (
                                    item.type === 'date' &&
                                    (item.show === undefined || item.show) &&
                                    (item.dateType === undefined || item.dateType === 'range')
                                  ) {
                                    return (
                                      <a-form-item
                                        class={`${prefixCls}-header-filterwrap-form-item`}
                                        label={item.label ? item.label : null}
                                        colon={false}
                                        validateStatus={item.validateStatus || ''}
                                        help={item.help || ''}
                                        labelAlign={filtersCurrent.labelAlign || 'right'}
                                        style={filtersCurrent.formItemStyle || ''}
                                      >
                                        <a-range-picker
                                          class={`${prefixCls}-filterwrap`}
                                          {...{ props: item }}
                                          {...{ on: omit(item, 'change') }}
                                          v-decorator={[
                                            item.field,
                                            { rules: item.rules, initialValue: item.defaultValue },
                                          ]}
                                          onChange={e => {
                                            this.filterChange(e, item);
                                          }}
                                          placeholder={item.placeholder || ['开始时间', '结束时间']}
                                          style={item.style || { width: '100%' }}
                                        />
                                      </a-form-item>
                                    );
                                  } else if (
                                    item.type === 'date' &&
                                    (item.show === undefined || item.show) &&
                                    item.dateType === 'normal' &&
                                    (item.mode === undefined || (item.mode && item.mode !== 'year'))
                                  ) {
                                    return (
                                      <a-form-item
                                        class={`${prefixCls}-header-filterwrap-form-item`}
                                        label={item.label ? item.label : null}
                                        colon={false}
                                        validateStatus={item.validateStatus || ''}
                                        help={item.help || ''}
                                        labelAlign={filtersCurrent.labelAlign || 'right'}
                                        style={filtersCurrent.formItemStyle || ''}
                                      >
                                        <a-date-picker
                                          class={`${prefixCls}-filter`}
                                          {...{ props: item }}
                                          {...{ on: omit(item, 'change') }}
                                          v-decorator={[
                                            item.field,
                                            { rules: item.rules, initialValue: item.defaultValue },
                                          ]}
                                          onChange={e => {
                                            this.filterChange(e, item);
                                          }}
                                          placeholder={item.placeholder || '请选择'}
                                          style={item.style || ''}
                                        />
                                      </a-form-item>
                                    );
                                  } else if (
                                    item.type === 'date' &&
                                    (item.show === undefined || item.show) &&
                                    item.dateType === 'normal' &&
                                    item.mode === 'year'
                                  ) {
                                    return (
                                      <fc-date-picker
                                        form={form}
                                        filtersCurrent={filtersCurrent}
                                        item={item}
                                        onChange={e => {
                                          this.filterChange(e, item);
                                        }}
                                        wrapClass={`${prefixCls}-header-filterwrap-form-item`}
                                      >
                                        {' '}
                                      </fc-date-picker>
                                    );
                                  }
                                })}
                              </div>
                            </div>
                          )}

                        {/* 显示模式2.2--------------- 结束*/}
                        {/* 显示模式2.3--------------- 高级搜索按钮 展开按钮位置(普通和aoto 模式 各有一个)*/}
                        {filtersCurrent.autoOptions && filtersCurrent.autoOptions.length > 0 && (
                          <div
                            class={`${prefixCls}-header-filterwrap-expand  ${
                              leftBtns.length !== 0 ||
                              rightBtns.length !== 0 ||
                              filtersBottomLeft.length !== 0 ||
                              filtersBottomRight.length !== 0 ||
                              bottomButtons.length !== 0 ||
                              autoLeft.length !== 0 ||
                              autoRight.length !== 0 ||
                              filtersBottomLeft.length !== 0 ||
                              filtersBottomRight.length !== 0 ||
                              (filtersCurrent.options && filtersCurrent.options.length !== 0) ||
                              $slots.header ||
                              $slots.cunstomHeader
                                ? ''
                                : 'halfLength'
                            }`}
                          >
                            <span
                              class={`${prefixCls}-header-filterwrap-expand-span`}
                              onClick={() => this.toggleAll()}
                            >
                              {!this.isAdvance
                                ? filtersCurrent.toggleText && filtersCurrent.toggleText[0]
                                  ? filtersCurrent.toggleText[0]
                                  : locale.Table.expend
                                : filtersCurrent.toggleText && filtersCurrent.toggleText[1]
                                ? filtersCurrent.toggleText[1]
                                : locale.Table.collapse}
                            </span>
                          </div>
                        )}
                        {/* 显示模式2.3--------------- 结束*/}

                        {/* 按钮部分3 -------*/}
                        {buttons.type === 'horizontal' &&
                          (autoRight.length > 0 || autoRight.length > 0) && (
                            <div class={`${prefixCls}-header-filterwrap-rightButtons`}>
                              <div class={`${prefixCls}-header-buttons-filterwrap`}>
                                <div class={`${prefixCls}-header-buttons-rightbtn`}>
                                  {this.renderBtns(prefixCls, autoRight, 'leftbtn')}
                                </div>
                              </div>
                            </div>
                          )}
                        {/* 按钮部分3 ------- 结束*/}
                      </div>
                    </div>
                    {/* 行2---------------结束*/}

                    {/* 行3---------------,行3,高级检索内容 */}
                    <div>
                      {/* this.isAdvance && ---> style={{display: this.isAdvance ? 'block' : 'none'}} */}
                      {
                        <div
                          class={`${prefixCls}-header-filterwrap-advance`}
                          style={{ display: this.isAdvance ? 'block' : 'none' }}
                        >
                          {filtersCurrent.autoOptions &&
                            filtersCurrent.autoOptions.length > 0 &&
                            filtersCurrent.autoOptions.map((item, index) => {
                              if (item.linkage && (item.show === undefined || item.show)) {
                                return (
                                  <a-form-item
                                    class={`${prefixCls}-header-filterwrap-advance-form-item-special`}
                                    label={item.label ? item.label : null}
                                    colon={false}
                                    validateStatus={item.validateStatus || ''}
                                    help={item.help || ''}
                                    labelAlign={filtersCurrent.labelAlign || 'left'}
                                    style={filtersCurrent.formItemStyle || ''}
                                    label-col={{ span: 24 }}
                                    wrapper-col={{ span: 24 }}
                                  >
                                    {/*  validateStatus={!this.form.getFieldError(item.field + '[values][1]') ? '' : 'error'} */}
                                    <a-row gutter={8}>
                                      <a-col span="8">
                                        <a-select
                                          class={`${prefixCls}-filterwrap`}
                                          v-decorator={[
                                            item.field + '[linkageType]',
                                            {
                                              rules: item.rules,
                                              initialValue: item.defaultLinkage,
                                            },
                                          ]}
                                          onChange={value => {
                                            item.currentLinkageType = value;

                                            delete item.defaultValue;
                                            item.isChange = true;
                                          }}
                                          notFoundContent={
                                            <span class="ant-select-not-found"></span>
                                          }
                                          style={item.style || ''}
                                        >
                                          {item.linkageOptions.map((option, index) => {
                                            return (
                                              <a-select-option key={index} value={option.value}>
                                                {option.label}
                                              </a-select-option>
                                            );
                                          })}
                                        </a-select>
                                      </a-col>
                                      {this.renderLinkage(item)}
                                    </a-row>
                                  </a-form-item>
                                );
                              } else if (
                                item.type === 'input' &&
                                (item.show === undefined || item.show)
                              ) {
                                return (
                                  <a-form-item
                                    class={`${prefixCls}-header-filterwrap-advance-form-item ${
                                      filtersCurrent.autoOptions.find(item => item.linkage)
                                        ? `${prefixCls}-header-filterwrap-advance-form-item-withLinkage`
                                        : ''
                                    }`}
                                    label={item.label ? item.label : null}
                                    colon={false}
                                    validateStatus={item.validateStatus || ''}
                                    help={item.help || ''}
                                    labelAlign={filtersCurrent.labelAlign || 'left'}
                                    style={filtersCurrent.formItemStyle || ''}
                                    label-col={{ span: 24 }}
                                    wrapper-col={{ span: 24 }}
                                  >
                                    <a-input
                                      class={`${prefixCls}-filterwrap`}
                                      {...{ props: item }}
                                      {...{ on: omit(item, 'pressEnter', 'change') }}
                                      v-decorator={[
                                        item.field,
                                        { rules: item.rules, initialValue: item.defaultValue },
                                      ]}
                                      onPressEnter={$event => {
                                        this.filterChange($event, item);
                                      }}
                                      style={item.style || ''}
                                    ></a-input>
                                  </a-form-item>
                                );
                              } else if (
                                item.type === 'select' &&
                                (item.show === undefined || item.show)
                              ) {
                                return (
                                  <a-form-item
                                    class={`${prefixCls}-header-filterwrap-advance-form-item ${
                                      filtersCurrent.autoOptions.find(item => item.linkage)
                                        ? `${prefixCls}-header-filterwrap-advance-form-item-withLinkage`
                                        : ''
                                    }`}
                                    label={item.label ? item.label : null}
                                    colon={false}
                                    validateStatus={item.validateStatus || ''}
                                    help={item.help || ''}
                                    labelAlign={filtersCurrent.labelAlign || 'left'}
                                    style={filtersCurrent.formItemStyle || ''}
                                    label-col={{ span: 24 }}
                                    wrapper-col={{ span: 24 }}
                                  >
                                    <a-select
                                      class={`${prefixCls}-filterwrap`}
                                      {...{ props: item }}
                                      {...{ on: omit(item, 'change') }}
                                      v-decorator={[
                                        item.field,
                                        { rules: item.rules, initialValue: item.defaultValue },
                                      ]}
                                      notFoundContent={<span class="ant-select-not-found"></span>}
                                      onChange={value => this.filterChange({}, item)}
                                      style={item.style || ''}
                                    >
                                      {item.options.map((option, index) => {
                                        return (
                                          <a-select-option key={index} value={option.value}>
                                            {option.label}
                                          </a-select-option>
                                        );
                                      })}
                                    </a-select>
                                  </a-form-item>
                                );
                              } else if (
                                item.type === 'treeSelect' &&
                                (item.show === undefined || item.show)
                              ) {
                                return (
                                  <a-form-item
                                    class={`${prefixCls}-header-filterwrap-advance-form-item ${
                                      filtersCurrent.autoOptions.find(item => item.linkage)
                                        ? `${prefixCls}-header-filterwrap-advance-form-item-withLinkage`
                                        : ''
                                    }`}
                                    label={item.label ? item.label : null}
                                    colon={false}
                                    validateStatus={item.validateStatus || ''}
                                    help={item.help || ''}
                                    labelAlign={filtersCurrent.labelAlign || 'left'}
                                    style={filtersCurrent.formItemStyle || ''}
                                    label-col={{ span: 24 }}
                                    wrapper-col={{ span: 24 }}
                                  >
                                    <a-tree-select
                                      class={`${prefixCls}-filterwrap`}
                                      {...{ props: omit(item, 'treeData') }}
                                      {...{ on: omit(item, 'change') }}
                                      tree-data={item.treeData}
                                      v-decorator={[
                                        item.field,
                                        { rules: item.rules, initialValue: item.defaultValue },
                                      ]}
                                      onChange={value => {
                                        this.filterChange({}, item);
                                      }}
                                      style={item.style || ''}
                                    />
                                  </a-form-item>
                                );
                              } else if (
                                item.type === 'date' &&
                                (item.show === undefined || item.show) &&
                                (item.dateType === undefined || item.dateType === 'range')
                              ) {
                                return (
                                  <a-form-item
                                    class={`${prefixCls}-header-filterwrap-advance-form-item ${
                                      filtersCurrent.autoOptions.find(item => item.linkage)
                                        ? `${prefixCls}-header-filterwrap-advance-form-item-withLinkage`
                                        : ''
                                    }`}
                                    label={item.label ? item.label : null}
                                    colon={false}
                                    validateStatus={item.validateStatus || ''}
                                    help={item.help || ''}
                                    labelAlign={filtersCurrent.labelAlign || 'left'}
                                    style={filtersCurrent.formItemStyle || ''}
                                    label-col={{ span: 24 }}
                                    wrapper-col={{ span: 24 }}
                                  >
                                    <a-range-picker
                                      class={`${prefixCls}-filterwrap`}
                                      {...{ props: item }}
                                      {...{ on: omit(item, 'change') }}
                                      v-decorator={[
                                        item.field,
                                        { rules: item.rules, initialValue: item.defaultValue },
                                      ]}
                                      // 设置自定义格式
                                      onChange={e => {
                                        this.filterChange(e, item);
                                      }}
                                      placeholder={item.placeholder || ['开始时间', '结束时间']}
                                      style={item.style || { width: '100%' }}
                                    />
                                  </a-form-item>
                                );
                              } else if (
                                item.type === 'date' &&
                                (item.show === undefined || item.show) &&
                                item.dateType === 'normal' &&
                                (item.mode === undefined || (item.mode && item.mode !== 'year'))
                              ) {
                                return (
                                  <a-form-item
                                    class={`${prefixCls}-header-filterwrap-advance-form-item ${
                                      filtersCurrent.autoOptions.find(item => item.linkage)
                                        ? `${prefixCls}-header-filterwrap-advance-form-item-withLinkage`
                                        : ''
                                    }`}
                                    label={item.label ? item.label : null}
                                    colon={false}
                                    validateStatus={item.validateStatus || ''}
                                    help={item.help || ''}
                                    labelAlign={filtersCurrent.labelAlign || 'left'}
                                    style={filtersCurrent.formItemStyle || ''}
                                    label-col={{ span: 24 }}
                                    wrapper-col={{ span: 24 }}
                                  >
                                    <a-date-picker
                                      class={`${prefixCls}-filterwrap`}
                                      {...{ props: item }}
                                      {...{ on: omit(item, 'change') }}
                                      v-decorator={[
                                        item.field,
                                        { rules: item.rules, initialValue: item.defaultValue },
                                      ]}
                                      onChange={e => {
                                        this.filterChange(e, item);
                                      }}
                                      placeholder={item.placeholder || '请选择'}
                                      style={item.style || ''}
                                    />
                                  </a-form-item>
                                );
                              } else if (
                                item.type === 'date' &&
                                (item.show === undefined || item.show) &&
                                item.dateType === 'normal' &&
                                item.mode === 'year'
                              ) {
                                return (
                                  <fc-date-picker
                                    form={form}
                                    filtersCurrent={filtersCurrent}
                                    item={item}
                                    onChange={e => {
                                      this.filterChange(e, item);
                                    }}
                                    wrapClass={`${prefixCls}-header-filterwrap-advance-form-item ${
                                      filtersCurrent.autoOptions.find(item => item.linkage)
                                        ? `${prefixCls}-header-filterwrap-advance-form-item-withLinkage`
                                        : ''
                                    }`}
                                  >
                                    {' '}
                                  </fc-date-picker>
                                );
                              }
                            })}

                          {/* {filtersCurrent.autoOptions && filtersCurrent.autoOptions.length > 0 && (
                            <a-form-item
                              class={`${prefixCls}-header-filterwrap-advance-form-item-button`}
                              label=""
                              colon={false}
                              label-col={{ span: 24 }}
                              wrapper-col={{ span: 24 }}
                              htmlFor="display: none"
                            >
                              <div
                                class={`${prefixCls}-header-filterwrap-advance-buttons`}
                                style={`marginTop: ${this.getFormItemHeight(filtersCurrent)}`}
                              >
                                <a-button
                                  type="primary"
                                  ghost
                                  class={`${prefixCls}-header-filterwrap-advance-search ${prefixCls}-header-filterwrap-advance-search-button`}
                                  onClick={event => this.btnClick(event, 'search', true)}
                                >
                                  查询
                                </a-button>
                                <a-button
                                  v-blurOnClick
                                  onClick={event => this.resetClick(event)}
                                  class={`${prefixCls}-header-filterwrap-advance-search-button`}
                                >
                                  重置
                                </a-button>
                              </div>
                            </a-form-item>
                          )} */}
                          {!(
                            filtersCurrent.autoOptions && filtersCurrent.autoOptions.length > 0
                          ) && <div class={`${prefixCls}-noOptions`}>{$slots.noOptions}</div>}
                        </div>
                      }
                    </div>
                    {/* 行3--------------- 结束*/}
                  </a-form>
                )}
              {/* 显示模式2---------------结束 */}

              {/* 按钮部分4 -------*/}
              {buttons.type === 'horizontal' &&
                (filtersBottomLeft.length > 0 || filtersBottomRight.length > 0) && (
                  <div class={`${prefixCls}-header-buttons`}>
                    <div class={`${prefixCls}-header-buttons-leftbtn`}>
                      {this.renderBtns(prefixCls, filtersBottomLeft, 'leftbtn')}
                    </div>
                    <div class={`${prefixCls}-header-buttons-rightbtn`}>
                      {this.renderBtns(prefixCls, filtersBottomRight, 'rightbtn')}
                    </div>
                  </div>
                )}
              {/* 按钮部分4 -------结束*/}
            </div>
          )}

        {$slots.header && <div class={`${prefixCls}-header expandTop`}>{$slots.header}</div>}
        {$slots.cunstomHeader && (
          <div class={`${prefixCls}-header expandTop`}>{$slots.cunstomHeader}</div>
        )}

        {/* aggrid */}
        <div
          class={`${prefixCls}-all ${
            // 1
            (!$slots.header &&
              (leftBtns.length !== 0 ||
                rightBtns.length !== 0 ||
                filtersBottomLeft.length !== 0 ||
                filtersBottomRight.length !== 0 ||
                bottomButtons.length !== 0 ||
                autoLeft.length !== 0 ||
                autoRight.length !== 0 ||
                filtersBottomLeft.length !== 0 ||
                filtersBottomRight.length !== 0 ||
                (filtersCurrent.options && filtersCurrent.options.length !== 0) ||
                (filtersCurrent.autoOptions && filtersCurrent.autoOptions.length !== 0))) ||
            // 2
            $slots.header ||
            // 3
            $slots.cunstomHeader
              ? this.isAdvance
                ? 'halfExpandTop'
                : 'expandTop'
              : this.isAdvance
              ? 'halfDefaultTop'
              : 'defaultTop'
          }`}
        >
          <AgGridVue
            style={{
              height: `${
                gridOptionsDeal.selectedAll ||
                gridOptionsDeal.showSelected === undefined ||
                (bottomButtons.length > 0 &&
                  bottomButtons.filter(item => {
                    return item.show === true || item.show === undefined;
                  }).length > 0) ||
                pagination.showPagination === undefined ||
                pagination.showPagination
                  ? 'calc(100% - 52px)'
                  : '100%'
              }`,
            }}
            class={`${prefixCls}-all-aggrid formTable ag-theme-material`}
            gridOptions={gridOptionsDeal}
            rowData={rowData}
            columnDefs={columnDefs}
            context="{ componentParent: this }"
            rowSelection={gridOptionsDeal.rowSelection || 'multiple'}
            rowDragManaged={this.gridOptions.rowDragManaged || false}
            enableSorting
            suppressRowClickSelection={true}
            onSelectionChanged={this.onSelectionChanged}
            isRowSelectable={this.isRowSelectable}
            overlayNoRowsTemplate={this.overlayNoRowsTemplate}
            {...{
              props: omit(
                gridOptionsDeal.attributeConfig,
                'rowData',
                'columnDefs',
                'isRowSelectable',
              ),
            }}
            {...{ on: omit(gridOptionsDeal.functionConfig, 'selectionChanged') }}
          ></AgGridVue>
          {/* 其他属性功能:
            1.

          */}
          {/* 中文版pagination */}
          {(gridOptionsDeal.selectedAll ||
            gridOptionsDeal.showSelected === undefined ||
            (bottomButtons.length > 0 &&
              bottomButtons.filter(item => {
                return item.show === true || item.show === undefined;
              }).length > 0) ||
            pagination.showPagination === undefined ||
            pagination.showPagination) &&
            rowData.length > 0 && (
              <div class={`${prefixCls}-all-pagination`}>
                <div class={`${prefixCls}-all-pagination-bottom-buttons`}>
                  {/* 页面全选 */}
                  {gridOptionsDeal.selectedAll && (
                    <span class={`${prefixCls}-all-pagination-bottom-buttons-checked`}>
                      <a-checkbox checked={this.isSelectedAll} onChange={this.selectedAll}>
                        {locale.Table.selectedAll}
                      </a-checkbox>
                    </span>
                  )}
                  {/* 选中文字 */}
                  {(gridOptionsDeal.showSelected || gridOptionsDeal.showSelected === undefined) &&
                    !gridOptionsDeal.selectedAll && (
                      <span class={`${prefixCls}-all-pagination-bottom-buttons-span`}>
                        {locale.Table.selected}
                        {tableChecked}
                        {locale.Table.term}
                      </span>
                    )}
                  {/* 全选右侧按钮 */}
                  <div class={`${prefixCls}-all-pagination-bottom-buttons-bottombtn`}>
                    {bottomButtons.map((item, index) => {
                      if (
                        item.dropDown &&
                        item.dropDown.options &&
                        Array.isArray(item.dropDown.options) &&
                        item.dropDown.options.length > 0
                      ) {
                        return (
                          (item.show || item.show === undefined) && (
                            <a-dropdown>
                              <a-menu
                                slot="overlay"
                                onClick={event => this.btnClick(event, event.key, item.isValidate)}
                              >
                                {item.dropDown.options.map(
                                  (menuItem, index) =>
                                    (menuItem.show || menuItem.show === undefined) && (
                                      <a-menu-item key={menuItem.handler} {...{ props: menuItem }}>
                                        {menuItem.text}
                                      </a-menu-item>
                                    ),
                                )}
                              </a-menu>
                              <a-button
                                {...{ props: item }}
                                class={`${prefixCls}-all-pagination-bottom-buttons-leftbtn-button ${prefixCls}-button`}
                                onClick={event =>
                                  this.btnClick(event, item.handler, item.isValidate)
                                }
                              >
                                {item.icon && (
                                  <fc-icon
                                    className={item.icon}
                                    size={`${
                                      !item.size
                                        ? '15px'
                                        : item.size === 'small'
                                        ? '12px'
                                        : item.size === 'large'
                                        ? '16px'
                                        : '15px'
                                    }`}
                                    color={item.iconColor ? item.iconColor : 'inherit'}
                                    style={{
                                      marginLeft: 0,
                                      marginRight: '8px',
                                      lineHeight: '16px',
                                    }}
                                  ></fc-icon>
                                )}
                                {item.text}
                                <a-icon type="down" />
                              </a-button>
                            </a-dropdown>
                          )
                        );
                      } else if (item.tooltip) {
                        return (
                          <a-tooltip {...{ props: item.tooltip.props }}>
                            <template slot="title">
                              <span>{item.tooltip.text}</span>
                            </template>
                            <a-button
                              {...{ props: item }}
                              class={`${prefixCls}-header-buttons-leftbtn-wrap-button ${prefixCls}-button`}
                              onClick={event => this.btnClick(event, item.handler, item.isValidate)}
                            >
                              {item.icon && (
                                <fc-icon
                                  className={item.icon}
                                  size={`${
                                    !item.size
                                      ? '15px'
                                      : item.size === 'small'
                                      ? '12px'
                                      : item.size === 'large'
                                      ? '16px'
                                      : '15px'
                                  }`}
                                  color={item.iconColor ? item.iconColor : 'inherit'}
                                  style={{ marginLeft: 0, lineHeight: '16px' }}
                                ></fc-icon>
                              )}
                              {item.text}
                              {item.tooltip.icon && (
                                <fc-icon
                                  className="FCquestion"
                                  size={`${
                                    !item.size
                                      ? '15px'
                                      : item.size === 'small'
                                      ? '12px'
                                      : item.size === 'large'
                                      ? '16px'
                                      : '15px'
                                  }`}
                                  color={item.iconColor ? item.iconColor : 'inherit'}
                                  style={{ marginLeft: '8px', marginRight: 0, lineHeight: '16px' }}
                                ></fc-icon>
                              )}
                            </a-button>
                          </a-tooltip>
                        );
                      } else {
                        {
                          return (
                            (item.show || item.show === undefined) && (
                              <a-button
                                {...{ props: item }}
                                class={`${prefixCls}-all-pagination-bottom-buttons-leftbtn-button ${prefixCls}-button`}
                                onClick={event =>
                                  this.btnClick(event, item.handler, item.isValidate)
                                }
                              >
                                {item.icon && (
                                  <fc-icon
                                    className={item.icon}
                                    size={`${
                                      !item.size
                                        ? '15px'
                                        : item.size === 'small'
                                        ? '12px'
                                        : item.size === 'large'
                                        ? '16px'
                                        : '15px'
                                    }`}
                                    color={item.iconColor ? item.iconColor : 'inherit'}
                                    style={{
                                      marginLeft: 0,
                                      marginRight: '8px',
                                      lineHeight: '16px',
                                    }}
                                  ></fc-icon>
                                )}
                                {item.text}
                              </a-button>
                            )
                          );
                        }
                      }
                    })}
                  </div>
                </div>

                {(pagination.showPagination === undefined || pagination.showPagination) && (
                  <a-pagination
                    class={`${prefixCls}-all-pagination-component`}
                    showLessItems
                    show-quick-jumper
                    show-size-changer
                    current={pagination.currentPage || pagination.current || 1}
                    pageSize={this.pageSize || 10}
                    total={Number(pagination.total) || 0}
                    onChange={this.changePage}
                    onShowSizeChange={this.changePage}
                    showTotal={total => `${locale.Table.allData}${total}${locale.Table.term}`}
                    pageSizeOptions={pagination.pageSizeOptions || ['10', '30', '50', '100']}
                  />
                )}
              </div>
            )}
        </div>
      </div>
    );
  },
};
